import apiClient from './api';

export const decodeEmail = (encodedEmail) => apiClient.post(`/authentification/decodeEmail`, { encodedEmail });

export const encodeEmail = (email) => apiClient.post(`/authentification/encodeEmail`, { email });

export const sendAuthentification = (email, password) => apiClient.post(`/authentification/insert`, { email, password });

export const getSecurityGroups = (email) => apiClient.get(`/microsoft-graph/groupes-securite/${email}`);